import { render } from "./DocRouterLink.vue?vue&type=template&id=7a34872d&ts=true"
import script from "./DocRouterLink.vue?vue&type=script&lang=ts"
export * from "./DocRouterLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__